import $ from 'jquery';
import debounce from 'just-debounce';
import layout from '../Layout';

export default class ProductZoom {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.$img = $(this.$el.children('img'));
    this.scale = this.$img[0].naturalWidth / this.$el[0].getBoundingClientRect().width;
    this.zoomable = this.scale >= 1.25;
    this.framerate = 60;
    this.zoomed = false;
    this.layoutHandler = this._layoutHandler.bind(this);

    this.resetZoom = this._resetZoom.bind(this);

    this.$img.on('rimg:load', () => {
      this.disableZoom();

      this.scale = this.$img[0].naturalWidth / this.$el[0].getBoundingClientRect().width;
      this.zoomable = this.scale >= 1.25;

      if (layout.isBreakpoint('L') && this.zoomable) {
        this.enableZoom();
        this._bindLayoutEvent();
      }
    });
  }

  enableZoom() {
    this.$el.addClass('product-image-zoomable');
    this._bindEvents();
  }

  disableZoom() {
    this.$el.removeClass('product-image-zoomable');
    this._unbindEvents();
    this._resetZoom();
  }

  unload() {
    this._unbindLayoutEvent();
    this._unbindEvents();
    this._resetZoom();
  }

  _bindEvents() {
    this.$el.on('click.product-zoom', (event) => {
      this._toggleZoom(event.clientX, event.clientY);
    });
    $(window).on('resize.product-zoom', this.resetZoom);
  }

  _unbindEvents() {
    this.$el.off('click.product-zoom');
    $(window).off('resize.product-zoom', this.resetZoom);
  }

  _bindLayoutEvent() {
    layout.onBreakpointChange(this.layoutHandler);
  }

  _unbindLayoutEvent() {
    layout.offBreakpointChange(this.layoutHandler);
  }

  _layoutHandler() {
    if (layout.isBreakpoint('L')) {
      this.enableZoom();
    } else {
      this.disableZoom();
    }
  }

  _toggleZoom(clientX, clientY) {
    if (!this.zoomed) {
      this.$el.on('mousemove.product-zoom', debounce((event) => {
        this._positionZoom(event.clientX, event.clientY);
      }, 1000 / this.framerate, true, true));
      this.$el.on('mouseout.product-zoom', () => this._resetZoom());
      this.$el.addClass('product-image-zoomed');
      this.$img.css('transform', `scale(${this.scale})`);
      this._positionZoom(clientX, clientY);
      this.zoomed = true;
    } else {
      this._resetZoom();
    }
  }

  _resetZoom() {
    this.$el.off('mousemove.product-zoom');
    this.$el.off('mouseout.product-zoom');
    this.$el.removeClass('product-image-zoomed');
    this.$img.css('transform', '');
    this.zoomed = false;
  }

  _positionZoom(clientX, clientY) {
    const figRect = this.$el[0].getBoundingClientRect();
    const imgRect = this.$img[0].getBoundingClientRect();
    const figHalfWidth = figRect.width / 2;
    const figHalfHeight = figRect.height / 2;
    const centerX = figRect.left + figHalfWidth;
    const centerY = figRect.top + figHalfHeight;
    const widthDiff = imgRect.width / 2 - figHalfWidth;
    const heightDiff = imgRect.height / 2 - figHalfHeight;
    const translateX = (centerX - clientX) / figHalfWidth * widthDiff / this.scale;
    const translateY = (centerY - clientY) / figHalfHeight * heightDiff / this.scale;

    this.$img.css(
      'transform',
      `scale(${this.scale}) translate(${translateX}px, ${translateY}px)`
    );
  }
}
